var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.789,
    height: 18.773,
    viewBox: "0 0 21.789 18.773",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fafafa;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520",
    transform: "translate(19739 14180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M483.333,1122.434a.668.668,0,0,0-.709.08l-6.522,5.218h-3.116a1.343,1.343,0,0,0-1.341,1.341v5.364a1.342,1.342,0,0,0,1.341,1.341H476.1l6.521,5.218a.672.672,0,0,0,.711.079.67.67,0,0,0,.38-.6v-17.432A.672.672,0,0,0,483.333,1122.434Z",
    transform: "translate(-20210.645 -15302.367)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    "data-name": "Rectangle 1913",
    className: "cls-1",
    width: 1.693,
    height: 10.738,
    rx: 0.846,
    transform: "translate(-19715.211 -14167.407) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    "data-name": "Rectangle 1914",
    className: "cls-1",
    width: 1.693,
    height: 10.738,
    rx: 0.846,
    transform: "translate(-19722.803 -14166.211) rotate(-135)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOff);
export default __webpack_public_path__ + "static/media/Icon_SoundOFF.60d915b6b5a5c02a9e39ec1984e36df8.svg";
export { ForwardRef as ReactComponent };